module.exports = __webpack_public_path__ + "static/media/Nursery_2.23f51ac8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/outskirts/nursery/Nursery_2.png
// module id = 1281
// module chunks = 3